<template>
  <!-- 新增平台方 -->
  <div class="page">
    <el-tabs v-model="activeName">
      <!-- 基本信息 -->
      <el-tab-pane :label="$t('pages.user.text8')" name="EssentialInformation" disabled>
        <EssentialInformation
          :activeName="activeName"
          @essentialInfor="essentialInfor"
          :params="params"
          :pageState="pageState"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('pages.operate.text15')" name="ServicePermissions" disabled>
        <ServicePermissions
          :activeName="activeName"
          @prev="prev"
          @service="service"
          :params="params"
          :pageState="pageState"
        />
      </el-tab-pane>
      <el-tab-pane :label="$t('pages.operate.text16')" name="WebPanel" disabled>
        <WebPanel
          @submit="submit"
          :activeName="activeName"
          @prev="prev"
          @web="web"
          :platformProperty="params.platformProperty"
          :params="params"
          :pageState="pageState"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="$t('pages.operate.text17')"
        name="AppPanel"
        disabled
        v-if="params.platformProperty == 1"
      >
        <AppPanel
          @submit="submit"
          @prev="prev"
          :activeName="activeName"
          :params="params"
          :pageState="pageState"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EssentialInformation from "./module/essentialInformation.vue";
import ServicePermissions from "./module/servicePermissions.vue";
import WebPanel from "./module/webPanel.vue";
import AppPanel from "./module/appPanel.vue";
import { mapState } from "vuex";
import { randomString } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pageState: "ADD", //页面状态 ADD新增 EDIT修改
      activeName: null,
      activeArr: [
        "EssentialInformation",
        "ServicePermissions",
        "WebPanel",
        "AppPanel",
      ],
      params: {
        location:'', //坐标
        region:'', //地域
        address: "", // 详细地址
        city: "", // 城市
        country: "", //国家
        province: "", //省份
        platformShortName: "", //平台方简称
        platformAllName: "", //平台方全称
        platformInfoImg: {
          //营业执照图片的名称和链接json
          imageName: "",
          imagePath: "",
        },
        contacts: "", //联系人
        contactsMail: "", //联系人邮箱
        platformDomain: "", //平台域名
        adminPassword: "", //admin登录密码
        adminUsername: "", // 	账号
        status: "", //状态
        remark: "", //备注

        appCode: "DEEBIKE", //appCode
        platformProperty: null, //平台方属性 公有 私有,0公有，1私有
        bikeCategoryId: [], //车辆类型id
        maxConnections: "", //车辆最大接入数，-1代表不限
        serveStartTime: "", //平台服务开始时间
        serveStopTime: "", //平台服务结束时间

        platformAdminBackground: {
          //平台方后台登录背景图片
          imageName: "",
          imagePath: "",
        },
        platformAdminLogo: {
          //平台方后台logo
          imageName: "",
          imagePath: "",
        },
        platformAdminName: "", //平台方后台名称

        appThemeColor: "", //app界面主题色

        belongCustomerId: "", //客户id
        platformCode: "", //平台方code
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    EssentialInformation,
    ServicePermissions,
    WebPanel,
    AppPanel,
  },
  mounted() {
    this.params = {
      region:'',
      location:'',
      address: "", // 详细地址
      city: "", // 城市
      country: "", //国家
      province: "", //省份
      platformShortName: "", //平台方简称
      platformAllName: "", //平台方全称
      platformInfoImg: {
        //营业执照图片的名称和链接json
        imageName: "",
        imagePath: "",
      },
      contacts: "", //联系人
      contactsMail: "", //联系人邮箱
      platformDomain: "", //平台域名
      adminPassword: "", //admin登录密码
      adminUsername: "", // 	账号
      status: "", //状态
      remark: "", //备注

      appCode: "DEEBIKE", //appCode
      platformProperty: null, //平台方属性 公有 私有,0公有，1私有
      bikeCategoryId: [], //车辆类型id
      maxConnections: 1, //车辆最大接入数，-1代表不限
      serveStartTime: "", //平台服务开始时间
      serveStopTime: "", //平台服务结束时间

      platformAdminBackground: {
        //平台方后台登录背景图片
        imageName: "",
        imagePath: "",
      },
      platformAdminLogo: {
        //平台方后台logo
        imageName: "",
        imagePath: "",
      },
      platformAdminName: "", //平台方后台名称

      appThemeColor: "#1F5BCC", //app界面主题色

      belongCustomerId: "", //客户id
      platformCode: "", //平台方code
    };
    this.pageState = this.$route.query.pageState;
    if (this.$route.query.pageState == "EDIT") {
      let id = this.$route.query.id;
      this.platformInfoById(id);
    } else {
      this.randomString();
      this.activeName = "EssentialInformation";
    }
  },
  methods: {
    //获取详情
    platformInfoById(id) {
      this.request.platformInfoById(id).then((res) => {
        this.params = {
          location: res.data.location,
          address: res.data.address, // 详细地址
          city: res.data.city, // 城市
          country: res.data.country, //国家
          province: res.data.province, //省份
          platformShortName: res.data.platformShortName, //平台方简称
          platformAllName: res.data.platformAllName, //平台方全称
          platformInfoImg: res.data.platformInfoImg, //营业执照图片的名称和链接json
          contacts: res.data.contacts, //联系人
          contactsMail: res.data.contactsMail, //联系人邮箱
          platformDomain: res.data.platformDomain, //平台域名
          adminPassword: res.data.post, //admin登录密码
          adminUsername: res.data.adminUsername, // 	账号
          status: res.data.status, //状态
          remark: res.data.remark, //备注

          appCode: res.data.appCode, //appCode
          platformProperty: res.data.platformProperty, //平台方属性 公有 私有,0公有，1私有
          bikeCategoryId: res.data.bikeCategoryId, //车辆类型id
          maxConnections: res.data.maxConnections, //车辆最大接入数，-1代表不限
          serveStartTime: res.data.serveStartTime, //平台服务开始时间
          serveStopTime: res.data.serveStopTime, //平台服务结束时间

          platformAdminBackground: res.data.platformAdminBackground, //平台方后台登录背景图片
          platformAdminLogo: res.data.platformAdminLogo, //平台方后台logo
          platformAdminName: res.data.platformAdminName, //平台方后台名称

          appThemeColor: res.data.appThemeColor, //app界面主题色

          belongCustomerId: null, //客户id
          platformCode: res.data.platformCode, //平台方code
          id: res.data.id,
        };
        this.activeName = "EssentialInformation";
      });
    },
    //自动生成密码
    randomString() {
      this.params.adminPassword = randomString(6);
    },
    //基本信息
    essentialInfor(e) {
      this.params = { ...this.params, ...e };
      delete this.params.regionList;
      this.activeName = "ServicePermissions";
    },
    service(e) {
      this.params = { ...this.params, ...e };
      this.activeName = "WebPanel";
      // console.log(this.params.platformProperty);
    },
    web(e) {
      this.params = { ...this.params, ...e };
      this.activeName = "AppPanel";
    },
    submit(e) {
      this.params = { ...this.params, ...e };
      this.params.belongCustomerId = this.platformData.id;
      this.params.region = this.platformData.region;
      if (this.pageState == "ADD") {
        this.request.platformAdd(this.params).then(() => {
          this.$message({
            type: "success",
            message: this.$t('pages.operate.text18'),
          });
          this.$router.go(-1);
        });
      } else {
        this.request.platformEdit(this.params).then(() => {
          this.$message({
            type: "success",
            message: this.$t('pages.operate.text19'),
          });
          this.$router.go(-1);
        });
      }
    },
    prev() {
      this.activeName =
        this.activeArr[this.activeArr.indexOf(this.activeName) - 1];
    },
  },
};
</script>

<style scoped>
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
</style>